export const REGISTER_USER = 'REGISTER_USER';
export const USER_REGISTERED = 'USER_REGISTERED';

export const LOGIN_USER = 'LOGIN_USER';
export const USER_LOGGEDIN = 'USER_LOGGEDIN';
export const LOGOUT_USER = 'LOGOUT_USER';
export const USER_LOGGEDOUT = 'USER_LOGGEDOUT';

export const SET_ALERT = 'SET_ALERT';
export const RESET_ALERT = 'RESET_ALERT';

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTBYID_REQUEST = 'GET_PRODUCTBYID_REQUEST';
export const GET_PRODUCTBYID_SUCCESS = 'GET_PRODUCTBYID_SUCCESS';

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_SHIPPING = 'ADD_SHIPPING';

export const ADD_TO_WISHLIST='ADD_TO_WISHLIST';
export const REMOVE_FROM_WISHLIST='REMOVE_FROM_WISHLIST';
            